import { analytics } from '@sezane/front-components';
import Cookies from 'js-cookie';
import { isWebview } from './utils';
import config from './config';
// eslint-disable-next-line import/no-cycle
import { getGlobalEData } from './components/globalE';
import environment from './env';
// eslint-disable-next-line import/no-mutable-exports
let context;
let site;
const productsInPage = [];
const subscriberKey = new URLSearchParams(window.location.search).get('sez_subscriberkey') || window.userData?.salesforceId;
const setContext = (appContext) => {
    context = appContext;
    site = `${context.site.code.toLowerCase()}_${context.currencyLabel}`;
};
const formatPrice = (price) => (price ? (price / 100).toFixed(2) : undefined);
// Nav history
let navPath = (window.sessionStorage ? JSON.parse(window.sessionStorage.getItem('navPath')) : []) || [];
const addNavPath = () => {
    navPath = [...navPath.slice(-1), window.document.title];
    if (window.sessionStorage) {
        window.sessionStorage.setItem('navPath', JSON.stringify([...navPath.slice(-1), window.document.title]));
    }
};
addNavPath();
const segmentConfig = {
    writeKey: config.segmentKey,
    cdnURL: config.segmentCdn,
};
const getContentType = () => {
    return window.contentType || document.title;
};
// Product in page
const addProductInPage = (product) => {
    productsInPage.push(product);
};
const getCurrentSizeUUID = (items) => {
    const selectedSize = window.location.hash.replace('#size-', '');
    const currentSize = items.find((item) => item.size === selectedSize);
    return currentSize?.uuid || items[0].uuid;
};
const getEmail = async () => {
    return window.userData?.email ? await analytics.getSha256(window.userData.email) : undefined;
};
const hashPhoneWithPlus = async (phone) => {
    if (!phone)
        return undefined;
    const e164 = phone.startsWith('+') ? phone : `+${phone}`;
    return analytics.getSha256(e164);
};
const hashPhoneWithoutPlus = async (phone) => {
    if (!phone)
        return undefined;
    const e164 = phone.startsWith('+') ? phone.slice(1) : phone;
    return analytics.getSha256(e164);
};
const getPhoneSha256 = async () => hashPhoneWithPlus(window.userData?.phone);
const getPhoneSha256NoPlus = async () => hashPhoneWithoutPlus(window.userData?.phone);
// Events
const productsSearched = async (searchTerm, countResults) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Products Searched', {
        event_id: analytics.getUniqueEventId('productsSearched'),
        query: searchTerm,
        'result-nb': countResults,
        country: globalEData?.countryISO,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        navPath: navPath.join('||'),
        isWebview: isWebview(),
        'adresse-email': await getEmail(),
        phone_sha256: await getPhoneSha256(),
        phone_sha256_no_plus: await getPhoneSha256NoPlus(),
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc'),
    });
};
const productListViewed = async (eventType = 'Product page') => {
    const instance = await analytics.getInstance(segmentConfig);
    const products = productsInPage.slice(0, 25);
    const globalEData = getGlobalEData();
    instance.track('Product List Viewed', {
        event_id: analytics.getUniqueEventId('productListViewed'),
        'type-contenu': 'Liste produit',
        'page-name': document.title,
        list_id: document.title,
        category: document.title,
        country: globalEData?.countryISO,
        content_category: products.map((product) => product.productCategory),
        content_ids: products.map((product) => product.sizeUUID),
        content_name: products.map((product) => product.productName),
        content_type: 'product_group',
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        currency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        navPath: navPath.join('||'),
        'event-type': eventType,
        products: products.map((product, index) => ({
            product_id: product.sizeUUID,
            sku: product.productEAN,
            name: product.productName,
            brand: product.productBrand,
            price: formatPrice(product.productPrice),
            position: index + 1,
            category: product.productCategory,
            productUUID: product.productUUID,
            productStatus: product.productStatus,
            url: product.productURL,
            product_code: product.productID,
            fs_color: product.fsColor,
            color: product.color,
            collection: product.collection,
        })),
        isWebview: isWebview(),
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc'),
    });
};
const productViewed = async ({ sizesSoldOut, ...product }) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Viewed', {
        event_id: analytics.getUniqueEventId('productViewed'),
        'type-contenu': 'Page Produit',
        'page-name': document.title,
        product_id: getCurrentSizeUUID(product.items),
        sku: product.productEAN,
        category: product.productCategory,
        name: product.productName,
        brand: product.productBrand.toLowerCase(),
        country: globalEData?.countryISO,
        variant: product.productVariant,
        price: formatPrice(product.productPrice),
        currency: context.currencyCode,
        value: formatPrice(product.productPrice),
        productStatus: product.productStatus,
        productUUID: product.productUUID,
        product_code: product.productID,
        content_category: product.productCategory,
        content_ids: product.sizeUUID,
        content_name: product.productName,
        content_type: 'product',
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        navPath: navPath.join('||'),
        'event-type': 'Product page',
        label: product.productName,
        url: product.productURL,
        isWebview: isWebview(),
        subscriber_key: subscriberKey,
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
        'adresse-email': await getEmail(),
        phone_sha256: await getPhoneSha256(),
        phone_sha256_no_plus: await getPhoneSha256NoPlus(),
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc'),
    });
    if (sizesSoldOut.length > 0) {
        instance.track('Size sold out', {
            event_id: analytics.getUniqueEventId('sizeSoldOut'),
            'type-contenu': 'Page Produit',
            'page-name': document.title,
            product_id: product.sizeUUID,
            category: product.productCategory,
            name: product.productName,
            variant: product.productVariant,
            price: formatPrice(product.productPrice),
            site,
            country: globalEData?.countryISO,
            siteBrand: context.brandCode,
            siteCurrency: context.currencyCode,
            langue: context.locale,
            environnement: environment,
            platform: 'web',
            label: product.productName,
            value: formatPrice(product.productPrice),
            size: sizesSoldOut.join(', '),
            productUUID: product.productUUID,
            sku: product.productEAN,
            isWebview: isWebview(),
            nonInteraction: 1,
            fs_color: product.fsColor,
            color: product.color,
            collection: product.collection,
        });
    }
};
const pageLoad = async (pageLoadData) => {
    const instance = await analytics.getInstance(segmentConfig);
    const userId = pageLoadData ? pageLoadData.userId : undefined;
    const email = pageLoadData ? pageLoadData.email : undefined;
    const phone = pageLoadData ? pageLoadData.phone : undefined;
    const salesforceId = pageLoadData && pageLoadData.salesforceId ? pageLoadData.salesforceId : undefined;
    const breadcrumb = pageLoadData.breadcrumb;
    const domain = window.location.hostname.replace(/(www-nocache|www)/, '');
    const globalEData = getGlobalEData();
    instance.page(document.title, {
        event_id: analytics.getUniqueEventId('pageLoad'),
        breadcrumb,
        navPath: navPath.join('||'),
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        'statut-connexion': userId ? 'Logged' : 'Unlogged',
        'type-contenu': getContentType(),
        'user-id': userId,
        isWebview: isWebview(),
        'adresse-email': email ? await analytics.getSha256(email) : undefined,
        subscriber_key: salesforceId || subscriberKey,
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc'),
    });
    if (navPath.length === 1) {
        instance.identify(userId, {
            event_id: analytics.getUniqueEventId('userIdentify'),
            'adresse-email': await analytics.getSha256(email),
            phone_sha256: await hashPhoneWithPlus(phone),
            phone_sha256_no_plus: await hashPhoneWithoutPlus(phone),
            country: globalEData?.countryISO,
            fbp: Cookies.get('_fbp'),
            fbc: Cookies.get('_fbc'),
            'pint-epik': Cookies.get('_epik'),
            breadcrumb,
            'internal-id': userId || new URLSearchParams(document.location.search).get('client_id'),
            isWebview: isWebview(),
        });
    }
    const hasRegistered = Cookies.get('accountCreated');
    const hasAuthenticated = Cookies.get('authenticated');
    if (hasRegistered) {
        instance.track('Signed Up', {
            event_id: analytics.getUniqueEventId('signedUp'),
            site,
            country: globalEData?.countryISO,
            siteBrand: context.brandCode,
            siteCurrency: context.currencyCode,
            langue: context.locale,
            environnement: environment,
            platform: 'web',
            navPath: navPath.join('||'),
            isWebview: isWebview(),
        });
        instance.identify(userId, {
            event_id: analytics.getUniqueEventId('userIdentify'),
            'adresse-email': await analytics.getSha256(email),
            phone_sha256: await hashPhoneWithPlus(phone),
            phone_sha256_no_plus: await hashPhoneWithoutPlus(phone),
        });
        Cookies.remove('accountCreated', { domain, path: '/' });
    }
    if (hasAuthenticated) {
        instance.track('Login', {
            event_id: analytics.getUniqueEventId('login'),
            site,
            country: globalEData?.countryISO,
            siteBrand: context.brandCode,
            siteCurrency: context.currencyCode,
            langue: context.locale,
            environnement: environment,
            platform: 'web',
            navPath: navPath.join('||'),
            isWebview: isWebview(),
            phone_sha256: await hashPhoneWithPlus(phone),
            phone_sha256_no_plus: await hashPhoneWithoutPlus(phone),
        });
        instance.identify(userId, {
            event_id: analytics.getUniqueEventId('userIdentify'),
            'adresse-email': await analytics.getSha256(email),
            phone_sha256: await hashPhoneWithPlus(phone),
            phone_sha256_no_plus: await hashPhoneWithoutPlus(phone),
        });
        Cookies.remove('authenticated', { domain, path: '/' });
    }
};
const productCustomisationViewed = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Personalization Viewed', {
        event_id: analytics.getUniqueEventId('productPersonalizationViewed'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        country: globalEData?.countryISO,
        sku: product.productEAN,
        name: product.productName,
        price: formatPrice(product.productPrice),
        label: product.productName,
        value: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
        nonInteraction: 1,
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const productWithoutCustomisation = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Without Product Personalization', {
        event_id: analytics.getUniqueEventId('productWithoutPersonalization'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        sku: product.productEAN,
        country: globalEData?.countryISO,
        name: product.productName,
        price: formatPrice(product.productPrice),
        label: product.productName,
        value: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const productWithCustomisation = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Personalization Clicked', {
        event_id: analytics.getUniqueEventId('productPersonalizationClicked'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        sku: product.productEAN,
        name: product.productName,
        country: globalEData?.countryISO,
        price: formatPrice(product.productPrice),
        label: product.productName,
        value: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const productCustomisationClosed = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Personalization Closed', {
        event_id: analytics.getUniqueEventId('productPersonalizationClosed'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        sku: product.productEAN,
        name: product.productName,
        price: formatPrice(product.productPrice),
        label: product.productName,
        value: formatPrice(product.productPrice),
        category: product.productCategory,
        country: globalEData?.countryISO,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const shopTheLook = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Pop-in shop the look viewed', {
        event_id: analytics.getUniqueEventId('popinShopTheLookViewed'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        sku: product.productEAN,
        name: product.productName,
        price: formatPrice(product.productPrice),
        value: formatPrice(product.productPrice),
        category: product.productCategory,
        country: globalEData?.countryISO,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const shopTheLookProductClicked = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Pop-in shop the look clicked', {
        event_id: analytics.getUniqueEventId('popinShopTheLookClicked'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        sku: product.productEAN,
        name: product.productName,
        country: globalEData?.countryISO,
        price: formatPrice(product.productPrice),
        value: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const error = async ({ errorType }) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Error page', {
        event_id: analytics.getUniqueEventId('errorPage'),
        'error-type': errorType,
        'page-name': document.title,
        url: window.location.href,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        'type-contenu': 'erreur',
        navPath: navPath.join('||'),
        label: errorType,
        isWebview: isWebview(),
        nonInteraction: 1,
    });
};
const popinGlobalE = async () => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Pop-in localisation', {
        event_id: analytics.getUniqueEventId('popinLocalisation'),
        'page-name': document.title,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
        nonInteraction: 1,
    });
};
const dynamicPopin = async (popinType) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Pop-in contribuee', {
        event_id: analytics.getUniqueEventId('popinContribuee'),
        'page-name': document.title,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        'type-contenu': popinType,
        isWebview: isWebview(),
        nonInteraction: 1,
    });
};
const popinWishlist = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Pop-in Wishlist Viewed', {
        event_id: analytics.getUniqueEventId('popinWishlistViewed'),
        'type-contenu': getContentType(),
        'page-name': document.title,
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        sku: product.productEAN,
        name: product.productName,
        price: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        label: product.productName,
        value: formatPrice(product.productPrice),
        isWebview: isWebview(),
        nonInteraction: 1,
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const popinWishlistClosed = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Pop-in Wishlist Closed', {
        event_id: analytics.getUniqueEventId('popinWishlistClosed'),
        'type-contenu': getContentType(),
        'page-name': document.title,
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        sku: product.productEAN,
        name: product.productName,
        country: globalEData?.countryISO,
        price: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        label: product.productName,
        value: formatPrice(product.productPrice),
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const productClicked = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Clicked', {
        event_id: analytics.getUniqueEventId('productClicked'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        sku: product.productEAN,
        category: product.productCategory,
        country: globalEData?.countryISO,
        name: product.productName,
        brand: product.productBrand.toLowerCase(),
        variant: product.productVariant,
        price: formatPrice(product.productPrice),
        productStatus: product.productStatus,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        url: product.productURL,
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const productAddedToCart = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Added', {
        event_id: analytics.getUniqueEventId('productAdded'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        country: globalEData?.countryISO,
        sku: product.productEAN,
        category: product.productCategory,
        name: product.productName,
        brand: product.productBrand?.toLowerCase(),
        variant: product.productVariant,
        price: formatPrice(product.productPrice),
        quantity: 1,
        productStatus: product.productStatus,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        currency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        url: product.productURL,
        'event-type': 'Product page', // @TODO Should be `Product page` or `Quick Shop` depending on the context
        label: product.productName,
        value: formatPrice(product.productPrice),
        isWebview: isWebview(),
        cart_id: Cookies.get('SezaneCartUuid'),
        subscriber_key: subscriberKey,
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
        'adresse-email': await getEmail(),
        phone_sha256: await getPhoneSha256(),
        phone_sha256_no_plus: await getPhoneSha256NoPlus(),
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc'),
    });
};
const productAddedWishlist = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Added to Wishlist', {
        event_id: analytics.getUniqueEventId('productAddedWishlist'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        name: product.productName,
        price: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        currency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        sku: product.productEAN,
        brand: product.productBrand.toLowerCase(),
        variant: product.productVariant,
        productStatus: product.productStatus,
        label: product.productName,
        value: formatPrice(product.productPrice),
        url: product.productURL,
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
        'adresse-email': await getEmail(),
        phone_sha256: await getPhoneSha256(),
        phone_sha256_no_plus: await getPhoneSha256NoPlus(),
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc'),
    });
};
const productRemovedWishlist = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Removed from Wishlist', {
        event_id: analytics.getUniqueEventId('productRemovedWishlist'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        name: product.productName,
        price: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        sku: product.productEAN,
        brand: product.productBrand.toLowerCase(),
        variant: product.productVariant,
        productStatus: product.productStatus,
        label: product.productName,
        value: formatPrice(product.productPrice),
        url: product.productURL,
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const quickshopViewed = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Quick Shop Viewed', {
        event_id: analytics.getUniqueEventId('productQuickShopViewed'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        sku: product.productEAN,
        category: product.productCategory,
        name: product.productName,
        country: globalEData?.countryISO,
        brand: product.productBrand.toLowerCase(),
        variant: product.productVariant,
        price: formatPrice(product.productPrice),
        currency: context.currencyCode,
        value: formatPrice(product.productPrice),
        productUUID: product.productUUID,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        label: product.productName,
        url: product.productURL,
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const quickshopClosed = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Quick Shop Closed', {
        event_id: analytics.getUniqueEventId('productQuickShopClosed'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        sku: product.productEAN,
        category: product.productCategory,
        name: product.productName,
        country: globalEData?.countryISO,
        brand: product.productBrand.toLowerCase(),
        variant: product.productVariant,
        price: formatPrice(product.productPrice),
        currency: context.currencyCode,
        value: formatPrice(product.productPrice),
        productUUID: product.productUUID,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        label: product.productName,
        url: product.productURL,
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const newsletterSubscription = async () => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Newsletter_Subscription', {
        event_id: analytics.getUniqueEventId('newsletterSubscription'),
        newsletterSubscriptionLocation: 'Footer',
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        label: 'Footer',
        platform: 'web',
        isWebview: isWebview(),
        subscriber_key: subscriberKey,
        'adresse-email': await getEmail(),
        phone_sha256: await getPhoneSha256(),
        phone_sha256_no_plus: await getPhoneSha256NoPlus(),
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc'),
    });
};
const productAlert = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product Alert', {
        event_id: analytics.getUniqueEventId('productAlert'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        name: product.productName,
        price: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        sku: product.productEAN,
        brand: product.productBrand.toLowerCase(),
        productStatus: product.productStatus,
        label: product.productName,
        value: formatPrice(product.productPrice),
        url: product.productURL,
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const sizeGuide = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Click size guide', {
        event_id: analytics.getUniqueEventId('clickSizeGuide'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        name: product.productName,
        price: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        sku: product.productEAN,
        productStatus: product.productStatus,
        label: product.productName,
        value: formatPrice(product.productPrice),
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const productTabDetail = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Click details', {
        event_id: analytics.getUniqueEventId('clickProductDetails'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        name: product.productName,
        price: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        sku: product.productEAN,
        productStatus: product.productStatus,
        label: product.productName,
        value: formatPrice(product.productPrice),
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
    });
};
const productTabWorkshop = async () => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Click workshops', {
        event_id: analytics.getUniqueEventId('clickWorkshops'),
        // atelier: $atelier,
        // label: $atelier,
        site,
        siteBrand: context.brandCode,
        country: globalEData?.countryISO,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
    });
};
const giftCardAdded = async (formData) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Gift Card Added', {
        event_id: analytics.getUniqueEventId('giftCardAdded'),
        'giftcard-amount': formData.amount,
        value: formData.amount,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        'adresse-email': await getEmail(),
        recipient: await analytics.getSha256(formData.recipient),
        phone_sha256: await getPhoneSha256(),
        phone_sha256_no_plus: await getPhoneSha256NoPlus(),
        isWebview: isWebview(),
    });
};
const searchClick = async () => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Search click', {
        event_id: analytics.getUniqueEventId('searchClick'),
        site,
        siteBrand: context.brandCode,
        country: globalEData?.countryISO,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
    });
};
const cookiePopin = async () => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Pop-in cookies', {
        event_id: analytics.getUniqueEventId('popinCookies'),
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
        nonInteraction: 1,
    });
};
const changeCountry = async (country) => {
    const instance = await analytics.getInstance(segmentConfig);
    instance.track('Change_Country', {
        event_id: analytics.getUniqueEventId('changeCountry'),
        location: country,
        country,
        label: country,
        site,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        isWebview: isWebview(),
    });
};
const productYouMaybeAlsoLikeClicked = async (product) => {
    const instance = await analytics.getInstance(segmentConfig);
    const globalEData = getGlobalEData();
    instance.track('Product you may also like clicked', {
        event_id: analytics.getUniqueEventId('productYouMayAlsoLikeClicked'),
        product_id: product.sizeUUID,
        product_code: product.productID,
        productUUID: product.productUUID,
        name: product.productName,
        price: formatPrice(product.productPrice),
        category: product.productCategory,
        site,
        country: globalEData?.countryISO,
        siteBrand: context.brandCode,
        siteCurrency: context.currencyCode,
        langue: context.locale,
        environnement: environment,
        platform: 'web',
        sku: product.productEAN,
        productStatus: product.productStatus,
        label: product.productName,
        value: formatPrice(product.productPrice),
        isWebview: isWebview(),
        fs_color: product.fsColor,
        color: product.color,
        collection: product.collection,
        zone: product.zone,
        productPosition: product.productPosition,
        ...Object.entries(product.originProduct).reduce((acc, [key, value]) => {
            acc[`origin_${key}`] = value;
            return acc;
        }, {}),
    });
};
document.addEventListener('DOMContentLoaded', () => {
    // Consent banner
    setTimeout(() => {
        if (document.querySelector('#onetrust-banner-sdk')) {
            cookiePopin();
        }
    }, 1000);
    // Switch country
    const hasSwitchedCountry = Cookies.get('switch_country');
    if (hasSwitchedCountry) {
        const globalEData = getGlobalEData();
        if (globalEData) {
            changeCountry(globalEData?.countryISO);
            Cookies.remove('switch_country');
        }
    }
    // AWIN
    const urlParams = new URLSearchParams(window.location.search);
    const awc = urlParams.get('awc');
    if (awc) {
        Cookies.set('tmpAwc', awc, {
            expires: 30,
            domain: window.location.host.replace('www.', '').replace('www-nocache.', ''),
        });
    }
});
// Public API
const API = {
    setContext,
    productsSearched,
    productListViewed,
    addProductInPage,
    productViewed,
    pageLoad,
    productCustomisationViewed,
    productWithoutCustomisation,
    productWithCustomisation,
    productCustomisationClosed,
    shopTheLook,
    error,
    popinGlobalE,
    popinWishlist,
    popinWishlistClosed,
    productClicked,
    productAddedToCart,
    productAddedWishlist,
    productRemovedWishlist,
    quickshopViewed,
    quickshopClosed,
    newsletterSubscription,
    productAlert,
    sizeGuide,
    productTabDetail,
    productTabWorkshop,
    giftCardAdded,
    searchClick,
    dynamicPopin,
    shopTheLookProductClicked,
    productYouMaybeAlsoLikeClicked,
};
window.analytics = API;
export default API;
